<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如列表A页面 -->
      </router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如详情B页面-->
    </router-view>
    <van-popup
      v-model="isShow"
      :close-on-click-overlay="false"
      v-if="isShow"
      round
    >
      <MyComment :data="datas" @handleIsShow="handleIsShow" />
    </van-popup>
  </div>
</template>
<script>
import MyComment from "@/toast/MyComment";
export default {
  data() {
    return {
      datas: {},
      isShow: false, //用户的评论弹框是否出现
    };
  },
  components: {
    MyComment,
  },
  created() {
    let that = this;

    var timer = setInterval(() => {
      if (localStorage.getItem("uid") != null) {
        clearInterval(timer);
        this.queryUserInfo();
        that.queryWaitCommentWish();
        that.getUploadToken();
      }
    }, 500);
  },
  // 查询用户是否有待评价的心愿
  methods: {
    async queryWaitCommentWish() {
      let { data } = await this.$api.queryWaitCommentWish();
      this.datas = data;
      if (this.datas == null) {
        // 当前无
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    // 获取七牛云token
    async getUploadToken() {
      let { data } = await this.$api.GetToken();
      localStorage.setItem("uploadToken", data);
    },
    handleIsShow(val) {
      this.isShow = val;
    },
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      localStorage.setItem("userId", data.id);
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #666666;
}
.container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff8d6;
  padding-bottom: 50px;
}
.custom-image .van-empty__image {
  width: 200px;
  height: auto;
  margin-bottom: 10px;
}
.van-loading {
  position: fixed !important;
  left: 50% !important;
  top: 40% !important;
  transform: translateX(-50%);
}
.van-uploader__preview-delete {
  display: flex;
  align-items: center;
  justify-content: center;
}
.van-uploader__preview-delete-icon {
  position: static !important;
  color: #fff !important;
  font-size: 4px !important;
  -webkit-transform: scale(1) !important;
  transform: scale(1) !important;
}
// 侧边功能区
.side_bars {
  position: fixed;
  right: -5px;
  bottom: 280px;
  z-index: 10000;
  img {
    display: block;
    width: 45px;
    height: 45px;
    margin-bottom: 7px;
  }
}

.van-badge{
  min-width: 14px !important;
}
</style>
